<template>
  <div class="block" v-loading.fullscreen.lock="loading">
    <subHeader :title="service.title" :subtitle="service.description" :img_header="service.img"></subHeader>

    <div class="container px-4" style="margin-top:130px;">
      <div class="row">
        <div class="col-sm-3">
          <steps :step="step_current" :steps="steps_collection" direction="vertical"></steps>
        </div>
        <div class="col-sm-5">
          <ClubPark v-if="step_current == 0" :label="'Selecciona un lugar'" :listSeats="listSeats"
            @resClub="resClub" :set-default="setSede"></ClubPark>

          <Tickets v-if="step_current == 1" :club="seat" @resVolver="resVolver" @resCarrito="resCarrito" :op="op">
          </Tickets>

          <Facturacion v-if="step_current == 2" :abonado="{}" @resFact="resFact" @resVolver="resVolver">
          </Facturacion>
        </div>
        <div class="col-sm-4">
          <Resumen></Resumen>
        </div>
      </div>
    </div>

    <!--Modal ClubMet-->

  </div>
</template>

<script>
//components
import subHeader from "@/components/common/subHeader";
import steps from "@/components/common/Steps";
import ClubPark from "@/components/common/ClubPark";
import Tickets from "./Tickets"
import Facturacion from "@/components/pages/abonados/Facturacion";
import Resumen from "./Resumen"

//services
import services from "@/services/services.service";
import moment from "moment";

import { mapGetters } from 'vuex'

export default {
  components: {
    subHeader,
    steps,
    ClubPark,
    Tickets,
    Facturacion,
    Resumen
  },
  data: () => ({
    loading: false,
    service: {},
    step_current: 0,
    steps_collection: [],
    listSeats: [],
    seat: {},
    carrito: [],
    form: {},
    afiliado: {},
    loaderClubmet: false,
    modalClubMet: false,
    setSede: null,
    op: null,
    clubmetForm: {
      docnumber: null,
      numbercard: null,
    },
    rulesClubmet: {
      docnumber: [
        { required: true, message: 'Campo requerido', trigger: 'blur' },
        { min: 3, max: 13, message: 'Longitud debe ser de 3 a 13 como máximo', trigger: ['blur', 'change'] }
      ],
      numbercard: [
        { required: true, message: 'Campo requerido', trigger: 'blur' },
        { min: 1, max: 7, message: 'La longitud debe ser de 1 a 7 como máximo', trigger: ['blur', 'change'] }
      ],
    }
  }),
  mounted() {
    this.init();
  },
  created() {
    this.$store.dispatch("updateSubRouter", true);
  },
  computed: {
    ...mapGetters(['totalPagar', 'getDateVisit'])

  },
  methods: {
    showError(message) {
      this.$alert(message, "Aviso", {
        confirmButtonText: "Entendido",
        type: "warning",
        center: true,
      });
    },
    async init() {
      this.loading = true;
      this.steps_collection = [];
      await services
        .get("entradas")
        .then((res) => {
          this.service = res.data.details;
          this.steps_collection = JSON.parse(res.data.details.steps);
          axios
            .post(`${process.env.API2}/v1/as/busquedaxareaxgeneral/3`)
            .then((res) => {


              if (res.data.length > 0) {
                const tmp = res.data.map((item) => {
                  const str = item.areaDescripcion;
                  const slug = str.toLowerCase().split(" (")[0].replace(/ /g, "-");

                  return {
                    idseat: item.codigoArea,
                    name: item.areaDescripcion,
                    city: item.distrito,
                    address: item.direccion,
                    latitud: item.latitud,
                    longitud: item.longitud,
                    imagenUrl: item.imagenUrl,
                    slug: slug
                  };
                });

                this.listSeats = tmp;


                //validando si existe el querystring sede
                const urlParams = new URLSearchParams(window.location.search);
                const sede = urlParams.get("sede");
                if (sede) {
                  const item = this.listSeats.find(element => element.slug === sede);
                  this.setSede = item ? item.idseat : null;
                }

              }
              //console.log(this.listSeats);
            });
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resVolver(step) {
      this.$store.dispatch("updateDateVisit", '');
      this.$store.dispatch("updateCarrito", []);
      this.step_current = step - 1
    },
    resClub(club) {
      this.seat = club;
      this.step_current++;
    },
    resCarrito(data) {
      this.carrito = data;
      this.step_current++;
    },
    saveVentaSPV() {
      this.loading = true
      //console.log(this.getDateVisit)
      let fecha = this.getDateVisit.split('/');
      let fecha2 = fecha[2] + '-' + fecha[1] + '-' + fecha[0];
      let date_visit = moment(fecha2).format("YYYY-MM-DD[T]HH:mm:ss")
      //let fecha = this.getDateVisit.split(/[-/]/).reverse().join("-");
      //console.log(fecha2)
      //console.log(moment(fecha2).format("YYYY-MM-DD[T]HH:mm:ss"))
      axios
        .post(`${process.env.API2}/v1/reserva/registroGeneral`, {
          cabeceraParameter: {
            ue: "001066",
            sede: "001",
            codigoVenta: "",
            fechaEmision: moment(date_visit).format("YYYY-MM-DD[T]HH:mm:ss"),
            tipoSistema: "ART",
            areaId: this.form.st0.idseat,
            tipoDocumentoId: this.form.st2.voucher,
            docNumero: this.form.st2.fndoc,
            nombre: this.form.st2.fname,
            total: this.totalPagar
          },
          cuerpoParameters: this.carrito
        })
        .then((res) => {
          this.loading = false;
          //alert(res.data)
          if (parseInt(res.data) > 0) {
            this.form.operation = parseInt(res.data);
            this.form.date_visit = this.getDateVisit
            axios
              .post(`${process.env.API1}/api/entradas/register`, this.form)
              .then((response) => {
                this.loading = false;
                if (response.data.status)
                  window.location.href = response.data.url;
                else alert(response.data.message);
              })
              .catch((err) => {
                this.loading = false;
              });

          } else {
            this.loading = false;
            this.showError("Lo sentimos, no se ha podido registrar la información.");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    resFact(data) {
      this.$confirm('Está a punto de ir con el proceso de pago, desea continuar?', 'info', {
        confirmButtonText: 'si, continuar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.form.st0 = this.seat;
        this.form.st1 = this.carrito;
        this.form.st2 = data
        this.saveVentaSPV()
      }).catch(() => { });
    },
    handleClose() {
      this.loaderClubmet = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.validateClubMet()
        } else {
          return false;
        }
      });
    },
    validateClubMet() {
      this.loaderClubmet = true
      axios
        .post(`${process.env.API8}/api/user/validate`, this.clubmetForm)
        .then((response) => {
          this.loaderClubmet = false
          console.log(response.data)
          if (response.data.status) {
            this.modalClubMet = false
            this.afiliado = response.data
            this.op = 1
          } else {
            this.op = null
            alert(response.data.message);
          }
          //if (response.data.status)
          //    window.location.href = response.data.url;
          //else alert(response.data.message);
        })
        .catch((err) => {
          this.loaderClubmet = false
        });
    },
    emptyAfiliado() {
      //alert();
      this.afiliado = {};
      this.op = null;
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/entradas/Index.vue